import {
  CONNECT_CHAT,
  CONNECT_CHAT_SUCCESS,
  CONNECT_CHAT_FAIL,
  DISCONNECT_CHAT,
  FETCH_ONLINE_USERS,
  SET_ONLINE_USERS,
  FETCH_MESSAGES,
  FETCH_MESSAGES_SUCCESS,
  FETCH_MESSAGES_FAIL,
  SEND_MESSAGE,
  SEND_MESSAGE_SUCCESS,
  SEND_MESSAGE_FAIL,
  RECEIVE_MESSAGE,
  MARK_MESSAGES_READ,
  SET_ACTIVE_CONVERSATION,
  CLEAR_ACTIVE_CONVERSATION,
  FETCH_NOTIFICATIONS,
  FETCH_NOTIFICATIONS_SUCCESS,
  FETCH_NOTIFICATIONS_FAIL,
  RECEIVE_NOTIFICATION,
  MARK_NOTIFICATION_READ,
  MARK_ALL_NOTIFICATIONS_READ,
  TOGGLE_CHAT_PANEL,
  SET_CHAT_PANEL_OPEN,
} from "./actionTypes"

// Connection
export const connectChat = () => ({
  type: CONNECT_CHAT,
})

export const connectChatSuccess = () => ({
  type: CONNECT_CHAT_SUCCESS,
})

export const connectChatFail = (error) => ({
  type: CONNECT_CHAT_FAIL,
  payload: error,
})

export const disconnectChat = () => ({
  type: DISCONNECT_CHAT,
})

// Users
export const fetchOnlineUsers = () => ({
  type: FETCH_ONLINE_USERS,
})

export const setOnlineUsers = (users) => ({
  type: SET_ONLINE_USERS,
  payload: users,
})

// Messages
export const fetchMessages = (conversationId) => ({
  type: FETCH_MESSAGES,
  payload: conversationId,
})

export const fetchMessagesSuccess = (messages) => ({
  type: FETCH_MESSAGES_SUCCESS,
  payload: messages,
})

export const fetchMessagesFail = (error) => ({
  type: FETCH_MESSAGES_FAIL,
  payload: error,
})

export const sendMessage = (message) => ({
  type: SEND_MESSAGE,
  payload: message,
})

export const sendMessageSuccess = (message) => ({
  type: SEND_MESSAGE_SUCCESS,
  payload: message,
})

export const sendMessageFail = (error) => ({
  type: SEND_MESSAGE_FAIL,
  payload: error,
})

export const receiveMessage = (message) => ({
  type: RECEIVE_MESSAGE,
  payload: message,
})

export const markMessagesRead = (conversationId) => ({
  type: MARK_MESSAGES_READ,
  payload: conversationId,
})

// Conversations
export const setActiveConversation = (userId) => ({
  type: SET_ACTIVE_CONVERSATION,
  payload: userId,
})

export const clearActiveConversation = () => ({
  type: CLEAR_ACTIVE_CONVERSATION,
})

// Notifications
export const fetchNotifications = () => ({
  type: FETCH_NOTIFICATIONS,
})

export const fetchNotificationsSuccess = (notifications) => ({
  type: FETCH_NOTIFICATIONS_SUCCESS,
  payload: notifications,
})

export const fetchNotificationsFail = (error) => ({
  type: FETCH_NOTIFICATIONS_FAIL,
  payload: error,
})

export const receiveNotification = (notification) => ({
  type: RECEIVE_NOTIFICATION,
  payload: notification,
})

export const markNotificationRead = (notificationId) => ({
  type: MARK_NOTIFICATION_READ,
  payload: notificationId,
})

export const markAllNotificationsRead = () => ({
  type: MARK_ALL_NOTIFICATIONS_READ,
})

// UI State
export const toggleChatPanel = () => ({
  type: TOGGLE_CHAT_PANEL,
})

export const setChatPanelOpen = (isOpen) => ({
  type: SET_CHAT_PANEL_OPEN,
  payload: isOpen,
})
